import { Injectable, ElementRef } from '@angular/core';//Permite la inyeccion de dependecias
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { OptionsZero } from './options-zero';
import { Globals } from './globals';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { SessionService } from '../session.service';


//jquery
declare var $: any;

@Injectable()
export class ZeroService {

    constructor(public http: HttpClient,
        private global: Globals,
        private translate: TranslateService) {
    }

    request(optionsParams: any) {        
        let defaults = new OptionsZero("");
        let options = Object.assign({}, defaults, optionsParams);
        let httpRequest;
        if(options.showLoading || options.showLoading == null || options.showLoading == undefined) {
            this.showLoading();
        }
        
        if (options.limpiarMensajes) {
            this.global.error = "";
            this.global.info = "";
        }
        let headerDict = {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'withCredentials': 'true',
            'Accept': 'application/json;charset=UTF-8',
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
        };
        let headerMerge = Object.assign({}, headerDict, options.headers);
        let headers = new HttpHeaders(headerMerge);

        let extras = {
            headers: headers,
            withCredentials: true,
            params: null,
            responseType: null
        };

        /* ----------------------------------------------------- */
        if (options.isFile) {
            extras.responseType = options.params.fileType;
            httpRequest = this.http.post(options.uri, options.params, extras);
            httpRequest.subscribe(
                (response: any) => {
                    console.log("Ok Respuesta de --> ", options);
                    if (options.ok) {
                        options.ok(response);
                    } else {
                        console.log("Debe implementar una funcion personalizada");
                    }
                },
                (error: any) => {
                    console.log("Error Respuesta de isFile--> ", error);
                    if(options.showLoading || options.showLoading == null || options.showLoading == undefined) {
                        this.hideLoading();
                    }
                }
            );
        /* ----------------------------------------------------- */
        } else {
            // if (options.headers) {

            // }
            switch (options.method) {
                case "GET":
                    httpRequest = this.http.get(options.uri, extras);
                    break;
                case "POST":
                    httpRequest = this.http.post(options.uri, options.params, extras);
                    break;
                case "PUT":
                    httpRequest = this.http.put(options.uri, options.params, extras);
                    break;
                case "DELETE":
                    httpRequest = this.http.delete(options.uri,  extras);
                    break;
                default:
                    httpRequest = this.http.post(options.uri, options.params, extras);
            }

            httpRequest.subscribe(
                response => {
                    console.log("Respuesta de --> ", options);
                    // Diagnostico: el cuerpo solo se imprimia en la rama isSingleResponse,
                    // asi que las peticiones de catalogo quedaban a ciegas.
                    console.log("[CUERPO]", options.uri, "| tipo:", typeof response,
                                "| claves:", response && typeof response === "object" ? Object.keys(response) : "(no objeto)",
                                "| valor:", response);

                    if (options.isSingleResponse) {
                        console.log(response);
                        this.processSingleResponse(response, options);
                    } else {
                        if (options.ok) {
                            options.ok(response);
                        }
                    }
                    if(options.showLoading || options.showLoading == null || options.showLoading == undefined) {
                        this.hideLoading();
                    }
                    console.log("Termina peticion loading=>", this.global.loading);

                },
                (error: HttpErrorResponse) => {
                    console.log("Error Respuesta de --> ", options);
                    console.log(<any>error);
                    if (error.error instanceof Error) {
                        console.log("Error en la invocacion del servicio - Cliente.");
                    } else {
                        console.log("Error en la invocacion del servicio - Servidor.", error);
                        if (error.error != null && error.error.responseCode) {
                            if (options.error) {
                                console.log("Respuesta de error personalizada");
                                options.error(error.error);
                            } else {
                                console.log("Respuesta de error por defecto", error.error);
                                this.processError(error.error);
                            }
                        } else {
                            console.log('error inesperado, no hay responseCode...');
                            // let e: HttpErrorResponse = error;
                            if(this.isErrorHttpTerminoSesion(error)){
                                console.log('procesando error...');
                                // this.processHttpStatus(error);
                                this.processHttpStatus(error, options);
                                //$("#msgCierreSesionBrowser").modal("show");
                            }else{
                                if (options.error) {
                                    options.error(error);
                                }
                                // this.processHttpStatus(error);
                                this.processHttpStatus(error, options);
                            }
                        }
                    }
                    if(options.showLoading || options.showLoading == null || options.showLoading == undefined) {
                        this.hideLoading();
                    }
                    console.log("Termina peticion loading=>", this.global.loading);
                }
            );
            // error => {
            //     this.hideLoading();
            // }
        }
    }

    processSingleResponse(response: any, options: OptionsZero) {
        if (response.ok) {
            console.log("Respuesta ok.");
            if (options.ok) {
                console.log("Ejecutando funcion ok personalizada.");
                options.ok(response);
            }
            console.log("options.showInfo=>", options.showInfo);
            if (options.showInfo) {
                this.global.info = response.responseCode.message;
            }

        } else {
            //si existen validaciones
            if (response.validations && response.validations.length > 0) {
                this.processValidations(response);
            } else {
                if (options.error) {
                    console.log("Respuesta de error personalizada");
                    options.error(response);
                } else {
                    console.log("Respuesta de error por defecto", response);
                    this.processError(response);
                }
            }

        }
    }

    processError(response: any) {
        if (!response.ok && response.responseCode) {
            this.global.error = response.responseCode.message;
        }
    }

    processValidations(response: any) {
        for (var i = 0; i < response.validations.length; i++) {
            this.global.error += response.validations[i].message + ". ";
        }
    }

    isErrorHttpTerminoSesion(error: HttpErrorResponse) {
        console.log(error);
        if (error.status && (error.status.toString() == '0' || error.status.toString() == '511')){
            return true;
        }else{
            return false;
        }
    }

    // processHttpStatus(error: HttpErrorResponse) {
    //     console.log("ESTATUS ERROR: " + error.status + " error: " + error);
    //     this.translate.get("HTTP" + error.status).subscribe((value: string) => {
    //         this.global.error = value;
    //     });
    // }

    processHttpStatus(error: HttpErrorResponse, params: any) {
        console.log("Opciones: ", params);
        console.log(error);
        if (error.status == 401) {
            //procesando error generico
            this.translate.get("HTTP" + error.status, { url: error.url }).subscribe((value: string) => {
                this.global.error = value;
            });
            // window.location.href = environment.uris.comunes.login;
        } else {
            //procesando error generico
            this.translate.get("HTTP" + error.status, { url: error.url }).subscribe((value: string) => {
                this.global.error = value
            });
        }

    }
    showLoading() {
        setTimeout(() => this.global.loading = true, 0)
    }

    hideLoading() {
        setTimeout(() => this.global.loading = false, 0)
    }

    closeInfo() {
        this.global.info = "";
    }

    closeError() {
        this.global.error = "";
    }

}
